import axios from "axios";
import { RunConfigService, ConfigService, storage } from "@nuskin/ns-util";

const FOOTER_DATA = storage.metadata.FOOTER_DATA;

export default {
  getFooterData
};

/**
 * Used to retrieve footer data from service or session storage
 * @returns Promise<data>
 */
async function getFooterData() {
  let footerData = readFooterDataFromSession();
  if (footerData) {
    return footerData;
  } else {
    footerData = await getFooterDataFromService();
    writeFooterDataToSession(footerData);
    return footerData;
  }
}

/**
 * Retrieve footer data from AEM service
 * @returns {} - footer data
 * @private
 */
async function getFooterDataFromService() {
  const marketConfig = ConfigService.getMarketConfig();
  const runConfig = RunConfigService.getRunConfig();
  const marketFooterUrl =
    `${marketConfig.siteUrl}` +
    `/apps/hello/services/marketfooter.` +
    `${runConfig.language}_${runConfig.country}.json`;
  const footerData = await axios.request({
    method: "get",
    url: marketFooterUrl,
    responseType: "json"
  });

  return footerData.data;
}

/**
 * Retrieve footer data from Session storage
 * @returns {} - footer data
 * @private
 */
function readFooterDataFromSession() {
  let storageFooterData = storage(FOOTER_DATA);

  if (storageFooterData) {
    const runConfig = RunConfigService.getRunConfig();

    if (
      runConfig.language === storageFooterData.currentDisplayLanguage &&
      runConfig.country === storageFooterData.currentDisplayCountry
    ) {
      return storageFooterData;
    } else {
      return null;
    }
  } else {
    return null;
  }
}

/**
 * Write footer data to Session storage
 * @private
 */
function writeFooterDataToSession(footerData) {
  if (footerData) {
    storage(FOOTER_DATA, footerData);
    return footerData;
  }
  return null;
}
